import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import EditableTable from '@/components/EditableTable';
import { Row, Col, Tooltip } from 'antd';
import { saveStackupToServer } from '../../LayoutExplorer/components/Stackup_v1/store/actionCreators';
import { CASCADE } from '../../../constants/pageType';
import { SettingOutlined } from '@ant-design/icons';
import BallSizePanel from '../components/ballSizePanel';
import { saveBallSize } from '../store/Impedance/action';

const domainColumns = [
  {
    title: "Connecting Nets",
    dataIndex: "nets",
    width: "30%"
  },
  {
    title: "Power Pins",
    dataIndex: "powerPins",
    width: "30%"
  },
  {
    title: "Reference Pins",
    dataIndex: "referencePins",
    width: "30%"
  }
]

class InterposerComponents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ballSizeVisible: false,
      ballSizeComps: []
    }
  }

  getInterposerData = (Components) => {
    let columns = [{
      title: "Port",
      dataIndex: "port",
      width: "10%"
    }], dataSource = [];
    for (let component of Components) {
      const { name, loadPorts } = component;
      const column = {
        title:
          <Fragment>
            {name}
            <Tooltip
              title={`Ball size setting.`}
              mouseLeaveDelay={0} mouseEnterDelay={0.3}
              classNames={{ root: 'icon-tooltip' }}
            >
              <SettingOutlined
                className="impedance-part-switch-icon impedance-package-ports-switch-icon"
                onClick={(e) => this.openBallSize(e, [name])}
              />
            </Tooltip>
          </Fragment>
        ,
        children: domainColumns.map(column => ({ ...column, dataIndex: `${name}-${column.dataIndex}` }))
      }
      column.children[0].render = (text = []) => {
        return <div className='cascade-interposer-component-on-cell'>{text.join(', ')}</div>
      }
      column.children[1].render = (text = []) => {
        return <div className='cascade-interposer-component-on-cell'>{text.join(', ')}</div>
      }
      column.children[2].render = (text = []) => {
        return <div className='cascade-interposer-component-on-cell'>{text.join(', ')}</div>
      }
      columns.push(column)
      for (let loadPort of loadPorts) {
        let portIndex = dataSource.findIndex(data => data.port === loadPort.port);
        if (portIndex > -1) {
          dataSource[portIndex][`${name}-powerPins`] = loadPort.powerPins;
          dataSource[portIndex][`${name}-referencePins`] = loadPort.referencePins;
          dataSource[portIndex][`${name}-nets`] = loadPort.nets;
        } else {
          dataSource.push({ port: loadPort.port, [`${name}-powerPins`]: loadPort.powerPins, [`${name}-referencePins`]: loadPort.referencePins, [`${name}-nets`]: loadPort.nets })
        }
      }
    }
    return { columns, dataSource }
  }

  stopClick = (e) => {
    e && e.preventDefault() && e.stopPropagation();
  }

  openBallSize = (e, comps) => {
    this.stopClick(e);
    this.setState({
      ballSizeVisible: true,
      ballSizeComps: comps
    })
  }

  closeBallSize = (props, isClose) => {
    const { currentDesignId } = this.props
    const { ballShape, ballSize, ballHeight, ballMiddle, ballMaterial, notGroupPositivePin, compTab } = props;
    if (isClose) {
      this.setState({
        ballSizeVisible: false,
        ballSizeComps: []
      })
    }
    this.props.saveBallSize(currentDesignId, ballShape, ballSize, ballHeight, ballMiddle, ballMaterial, notGroupPositivePin, compTab)
  }

  render() {
    const { data, ballSizeMap, currentDesignId } = this.props;
    const { ballSizeVisible, ballSizeComps } = this.state
    return data.map(domain => {
      const { content } = domain;
      const { Components = [] } = content;
      const { columns, dataSource } = this.getInterposerData(Components);
      return <Row className='space-16'>
        <Col span={24} className='cascade-setup-border'>
          <span className="font-bold cascade-setup-title-color">Interposer Ports</span>
          <EditableTable
            rowKey={(record) => record.port}
            columns={columns}
            size="small"
            dataSource={dataSource || []}
            tableLayout="fixed"
            className="cascade-components-table"
          />
        </Col>
        {
          ballSizeVisible &&
          <BallSizePanel
            data={ballSizeMap}
            title={`Ball Size Setting`}
            closePanel={(props, isClose) => this.closeBallSize(props, isClose)}
            comps={ballSizeComps}
            pcbId={currentDesignId}
            saveStackupToServer={this.props.saveStackupToServer}
            product={CASCADE}
          />
        }
      </Row>
    })
  }
}

const mapState = (state) => {
  const { CascadeReducer: {
    Impedance: { data = [], page } } } = state
  const layout = data.find(item => item.designId === page);
  return {
    data: layout ? layout.powerDomains || [] : [],
    ballSizeMap: layout ? layout.ballSizeMap : {},
    currentDesignId: page,
  };
}

const mapDispatch = (dispatch) => ({
  saveStackupToServer(stackupData, designID) {
    dispatch(saveStackupToServer(stackupData, designID))
  },
  saveBallSize(pcbId, ballShape, ballSize, ballHeight, ballMiddle, ballMaterial, notGroupPositivePin, compTab) {
    dispatch(saveBallSize(pcbId, ballShape, ballSize, ballHeight, ballMiddle, ballMaterial, notGroupPositivePin, compTab))
  },
})

export default connect(mapState, mapDispatch)(InterposerComponents);
